import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { ButtonComponent, ClipboardCopy, WindowRef } from '@recruitee/user-interface';

import { DynamicGeneratedPasswordConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class GeneratedPasswordInput extends DynamicFormInput<DynamicGeneratedPasswordConfig> {}

const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 14;
const ALLOWED_CHARACTERS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$';

@Component({
  selector: 'rti-generated-password-input',
  templateUrl: './generated-password-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TranslatePipe],
})
export class GeneratedPasswordInputComponent {
  @Input() public input: GeneratedPasswordInput;

  constructor(
    private clipboardCopy: ClipboardCopy,
    private windowRef: WindowRef,
  ) {}

  public ngOnInit(): void {
    const generatedPassword = this.generatePassword();
    this.input.control.setValue(generatedPassword);
  }

  public copyGeneratedPassword(): void {
    this.clipboardCopy.fromString(this.input.control.value);
  }

  private getPasswordLength(): number {
    return (
      Math.floor(Math.random() * (MAX_PASSWORD_LENGTH - MIN_PASSWORD_LENGTH + 1)) +
      MIN_PASSWORD_LENGTH
    );
  }

  private getRandomBytes(passwordLength: number): Uint32Array {
    const windowReference = this.windowRef.nativeWindow;
    const result = new Uint32Array(passwordLength);
    windowReference.crypto.getRandomValues(result);
    return result;
  }

  private generatePassword(): string {
    const passwordLength = this.getPasswordLength();
    return Array.from(this.getRandomBytes(passwordLength))
      .map(character => ALLOWED_CHARACTERS[character % ALLOWED_CHARACTERS.length])
      .join('');
  }
}
